import { Constant } from '@configs/index';
import { atom } from 'recoil';
import { RecoilAtomKeys } from '../RecoilKeys';

const dashboardState: any = atom({
    key: RecoilAtomKeys.GENESISES_DASHBOARD_PARMAS,
    default: Constant.SEARCH_FORM_DATA.DASHBOARD
});

const openListState: any = atom({
    key: RecoilAtomKeys.GENESISES_OPENLIST_PARMAS,
    default: Constant.SEARCH_FORM_DATA.DEFAULT
});

const closeListState: any = atom({
    key: RecoilAtomKeys.GENESISES_CLOSELIST_PARMAS,
    default: Constant.SEARCH_FORM_DATA.CLOSE_DEFAULT
});

const searchFormAtom = {
    dashboardState,
    openListState,
    closeListState
};

export default searchFormAtom;
